export const scanInterpretationData = {
  id: '',
  subject: '',
  topic: '',
  title: '',
  scannedImage: '',
  extractedText: '',
  cleanQuestion: '',
  detectedQuestions: [] as Array<{
    number: number;
    text: string;
    questionType: string;
    whatIsBeingAsked: string;
    keyTerms: string[];
  }>,
  overallSubject: {
    name: '',
    confidence: '' as 'high' | 'medium' | 'low',
    topicsDetected: [] as string[],
  },
  detectedEquations: [] as string[],
  suggestedNextSteps: [] as string[],
  explanation: {
    summary: '',
    steps: [] as Array<{
      number: number;
      title: string;
      content: string[];
      result: string;
    }>,
    followUpQuestions: [] as string[],
  },
};